<template>
  <b-modal
    id="add-block-modal"
    :title="trans('new_block')"
    ok-only
    size="lg"
    :ok-title="trans('close')"
  >
    <b-tabs pills vertical content-class="mt-3">
      <b-tab :title="trans('design')">
        <p>
          <strong>{{ trans('design_and_media') }}</strong>
          <small class="d-block">{{ trans('design_about')}}</small>
        </p>
        <b-row class="m-4">
          <b-col v-for="(option, index) in contentBlockOptions" :key="index" class="px-1 col-6 mb-2">
            <b-button
              variant="outline-primary"
              size="sm"
              block
              @click="onClick(option.type)"
              :disabled="isDisabled(option.type)"
            >
              <span v-if="option.symbols" v-html="option.symbols"></span>
              <span>{{ option.label }}</span>
            </b-button>
          </b-col>
        </b-row>
        <hr>
        <strong><i class="fa fa-info-circle"></i> {{ trans('tile_or_card')}}</strong>
        <small class="d-block">
          {{ trans('tile_card_about')}}
        </small>
      </b-tab>
      <b-tab :title="trans('form_management')">
        <p>
          <strong>{{ trans('form_management') }}</strong>
          <small class="d-block">{{ trans('form_management_about') }}</small>
        </p>
        <b-row class="m-4">
          <b-col v-for="(option, index) in entityBlockOptions" :key="index" class="px-1 col-6 mb-2">
            <b-button
              variant="outline-primary"
              size="sm"
              block
              @click="onClick(option.type)"
              :disabled="isDisabled(option.type)"
            >
              <span v-if="option.symbols" v-html="option.symbols"></span>
              <span>{{ option.label }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab :title="trans('business')">
        <p>
          <strong>{{ trans('business') }}</strong>
          <small class="d-block">{{ trans('business_about') }}</small>
        </p>
        <b-row v-if="sellableBlockOptions.length > 0" class="m-4">
          <b-col v-for="(option, index) in sellableBlockOptions" :key="index" class="px-1 col-6 mb-2">
            <b-button
              variant="outline-primary"
              size="sm"
              block
              @click="onClick(option.type)"
              :disabled="isDisabled(option.type)"
            >
              <span v-if="option.symbols" v-html="option.symbols"></span>
              <span>{{ option.label }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab v-if="organization.has_microsite_quiz" :title="trans('quiz')">
        <b-row class="m-4">
          <b-col v-for="(option, index) in quizBlockOptions" :key="index" class="px-1 col-6 mb-2">
            <b-button
              variant="outline-primary"
              size="sm"
              block
              @click="onClick(option.type)"
            >
              <span v-if="option.symbols" v-html="option.symbols"></span>
              <span>{{ option.label }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab v-if="organization.has_amilia" title="Amilia">
        <b-row class="m-4">
          <b-col class="px-1">
            <b-button
              v-for="(option, index) in amiliaBlockOptions" :key="index"
              variant="outline-primary"
              size="sm"
              block
              @click="onClick(option.type)"
            >
              <span v-if="option.symbols" v-html="option.symbols"></span>
              <span>{{ option.label }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      page: Object,
      blocks: Array,
    },
    data() {
      return {
        trans: trans,
        tab: 0,
        contentBlockOptions: _.compact([
          {type: 'one-column', label: trans('text'), symbols: '<i class="fa fa-font"></i>'},
          {type: 'hero', label: trans('block_hero'), symbols: '<i class="fa fa-image"></i>'},
          {type: 'tile', label: trans('tile'), symbols: '<i class="fa fa-align-justify"></i>'},
          {type: 'card', label: trans('card'), symbols: '<i class="fa fa-square"></i>'},
          {type: 'video-tile', label: `${trans('video')} (${trans('tile').toLowerCase()})`, symbols: '<i class="fa fa-video"></i>'},
          {type: 'video-card', label: `${trans('video')} (${trans('card').toLowerCase()})`, symbols: '<i class="fa fa-video"></i>'},
          {type: 'audio', label: `${trans('audio')}`, symbols: '<i class="fa fa-music"></i>'},
          {type: 'html', label: `${trans('HTML')}`, symbols: '<i class="fa fa-code"></i>'},
          {type: 'alert', label: `${trans('alert')}`, symbols: '<i class="fa fa-info-circle"></i>'},
          {type: 'search', label: `${trans('search')}`, symbols: '<i class="fa fa-search"></i>'},
          {type: 'tabs', label: `${trans('tabs')}`, symbols: '<i class="fa fa-folder"></i>'},
          {type: 'table', label: `${trans('table')}`, symbols: '<i class="fa fa-table"></i>'},
          {type: 'links', label: `${trans('child_page_links')}`, symbols: '<i class="fa fa-link"></i>'}
        ]),
        entityBlockOptions: _.compact([
          {type: 'form-card', label: trans('form'), symbols: '<i class="fa fa-pen-square"></i>'},
          {type: 'document-card', label: trans('document'), symbols: '<i class="fa fa-file-pdf"></i>'},
          {type: 'location-card', label: trans('location'), symbols: '<i class="fa fa-map-marked-alt"></i>'},
          {type: 'my-account-link', label: trans('link_to_my_account'), symbols: '<i class="fa fa-user"></i>'},
          {type: 'staff-login-link', label: trans('link_to_staff_login'), symbols: '<i class="fa fa-chalkboard-teacher"></i>'},
          {type: 'calendar', label: trans('calendar'), symbols: '<i class="fa fa-calendar"></i>'},
          this.organization.id == 5 || this.organization.id == 141 ? {type: 'form-answers', label: trans('form_answers'), symbols: '<i class="fa fa-newspaper"></i>'} : null,
          this.organization.has_teams ? {type: 'team-standings', label: trans('team_standings'), symbols: '<i class="fa fa-users"></i>'} : null,
          this.organization.has_teams ? {type: 'teams-schedule', label: trans('teams_schedule'), symbols: '<i class="fa fa-calendar"></i>'} : null,
          this.organization.has_teams ? {type: 'player-stats', label: trans('player_stats'), symbols: '<i class="fa fa-user"></i>'} : null,
          {type: 'attendance', label: trans('attendance_list'), symbols: '<i class="fa fa-clipboard-list"></i>'},
        ]),
        sellableBlockOptions: _.compact([
          this.organization.has_bookings ? {type: 'package-card', label: trans('package'), symbols: '<i class="fa fa-box-open"></i>'} : null,
          this.organization.has_bookings ? {type: 'bookings', label: trans('bookings'), symbols: '<i class="fa fa-calendar-check"></i>'} : null,
          {type: 'products', label: trans('products'), symbols: '<i class="fa fa-shopping-cart"></i>'},
          this.organization.has_bookings && this.organization.id == 5 ? {type: 'am-class-card', label: trans('class'), symbols: '<i class="fa fa-fw fa-calendar-day"></i>'} : null,
          this.organization.id == 5 || this.organization.id == 1120 || this.organization.id == 1115 || this.organization.id == 1047 || this.organization.id == 1047 || this.organization.id == 667 || this.organization.id == 1115 || this.organization.id == 1452 ? {type: 'ecommerce-card', label: trans('ecommerce'), symbols: '<i class="fa fa-file-invoice-dollar"></i>'} : null,
        ]),
        amiliaBlockOptions: _.compact([
          {type: 'amilia-program', label: trans('program')},
          {type: 'amilia-activity', label: trans('activity')},
          {type: 'amilia-activity-list', label: trans('list_of_activities')},
          {type: 'amilia-membership', label: trans('membership')},
        ]),
        quizBlockOptions: _.compact([
          {type: 'radio-buttons', label: trans('question'), symbols: '<i class="fa fa-question"></i>'},
          {type: 'one-column', label: trans('text'), symbols: '<i class="fa fa-font"></i>'},
          {type: 'hero', label: trans('block_hero'), symbols: '<i class="fa fa-image"></i>'},
          {type: 'tile', label: trans('tile'), symbols: '<i class="fa fa-align-justify"></i>'},
          {type: 'video-tile', label: `${trans('video')} (${trans('tile').toLowerCase()})`, symbols: '<i class="fa fa-video"></i>'},
          {type: 'html', label: `${trans('HTML')}`, symbols: '<i class="fa fa-code"></i>'},
        ]),
      }
    },
    methods: {
      onClick(type) {
        this.$emit('add', type)
      },
      isDisabled(type) {
        // Bookings and products can only appear once on the page!
        // Bookings can only be on a top page without child pages!
        if (['bookings', 'products'].indexOf(type) >= 0) {
          if (type == 'bookings' &&
            (this.page.page_id != null || this.page.child_pages.length > 0))
            return true
          return !!_.find(this.blocks, {type: 'bookings'}) || !!_.find(this.blocks, {type: 'products'})
        }
        return false
      },
    },
    mounted() {
      window.addBlockModal = this
    },
  }
</script>
